import { SubmitAutomatedSupportFeedbackArgs } from 'types/api/arguments/submit-automated-support-feedback-args'

import { api } from './api'

export const submitAutomatedSupportFeedback = (args: SubmitAutomatedSupportFeedbackArgs) =>
  api.post(`/users/${args.userId}/msg_threads/${args.conversationId}/automated_support_feedback`, {
    rating: args.rating,
    help_center_session_id: args.helpCenterSessionId,
    survey_version: args.surveyVersion,
    feedback_for: args.feedbackFor,
    comment: args.comment,
  })
